






































































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {$, ID, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import TipoOcorrenciaSucesso from '../../model/resource/TipoOcorrenciaSucesso'

const metaInfo = () => ({
    title: $.t('view.persist.occurrenceTypeSucessPersist.title'),
})

@Component({
    metaInfo,
})
export default class OccurrenceTypeSucessPersistView extends Vue {
    @Prop({type: [String, Number]}) id?: ID

    AppConfig = AppConfig

    listToPersist: TipoOcorrenciaSucesso[] = []

    get editMode() {
        return Boolean(this.id)
    }

    created() {
        this.$set(this.listToPersist, 0, new TipoOcorrenciaSucesso())
    }

    async mounted() {
        if (this.id) await this.listToPersist[0].getTipoOcorrencia(this.id)
        $.await.done('getOccurrenceType')
    }

    addItem() {
        this.listToPersist.push(new TipoOcorrenciaSucesso())
    }

    removeItem(item: TipoOcorrenciaSucesso) {
        const index = this.listToPersist.indexOf(item)
        if (index > -1) {
            this.listToPersist.splice(index, 1)
            this.$forceUpdate()
        }
    }

    async persist() {
        await TipoOcorrenciaSucesso.persistLoteTipoOcorrencia(this.listToPersist)
        successAndPush('system.success.persist', '/manage/occurrence-type-sucess/list')
    }
}
